import React, { useEffect, useRef } from 'react'
import { TtIcon } from '@23/react'
import { logMessage } from '../../../../Logging/sentry'

import './VideoPreview.scss'

interface VideoPreviewProps {
  deviceId: string
}

const VideoPreview = ({ deviceId }: VideoPreviewProps) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (!videoRef.current) return
    if (!deviceId) {
      videoRef.current.srcObject = null
      videoRef.current.pause()
    } else {
      navigator.mediaDevices
        .getUserMedia({
          video: {
            deviceId: { exact: deviceId },
            width: { ideal: 1920 },
          },
        })
        .then(async (stream) => {
          if (!videoRef.current) return
          const videoStreamTrack = stream.getVideoTracks()[0]
          videoRef.current.srcObject = new MediaStream([videoStreamTrack])
          videoRef.current.autoplay = true
          await videoRef.current.play()
        })
        .catch((e: Error) => {
          logMessage(
            'Issue occurred while previewing video in device selector.',
            {
              level: 'warning',
              extra: { deviceId, cause: e },
            }
          )
        })
    }
  }, [deviceId])

  return (
    <div className="video-preview">
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video className="video-preview-video" ref={videoRef} />
      <TtIcon
        className="video-preview-icon"
        library="one/webinars"
        name="camera-off"
      />
    </div>
  )
}

export { VideoPreview }
